import { ColTypeDef, ICellRendererParams } from "ag-grid-community";
import React from "react";

import { Skeleton } from "../../../atoms/Skeleton";
import { AvatarProfile } from "../../../molecules/AvatarProfile";

// Custom cell renderer for employee columns with avatar and name
const EmployeeCellRenderer = (params: ICellRendererParams) => {
	// Expect the value to be an object with employeeId and employeeName
	const employeeData = params.value;

	if (!employeeData || !employeeData._id || !employeeData.name) {
		return (
			<div className="flex size-full items-center justify-center">
				<span aria-label="No employee data" className="text-neutral-6"></span>
			</div>
		);
	}

	return (
		<div className="flex h-full items-center justify-start">
			<AvatarProfile
				employeeId={employeeData._id}
				employeeName={employeeData.name}
				avatarSize={20}
				textSize="paragraph-3"
				textWeight="regular"
				forceHardReload
			/>
		</div>
	);
};

const EmployeeCol: ColTypeDef = {
	cellRenderer: EmployeeCellRenderer,
	cellRendererParams: {
		// Add any props you want to pass to the renderer
		showAvatar: true,
		avatarSize: 20,
		textSize: "paragraph-3",
		textWeight: "regular",
	},
	comparator: (valueA, valueB) => {
		const nameA = valueA?.name || "";
		const nameB = valueB?.name || "";
		return nameA.localeCompare(nameB);
	},

	cellRendererSelector: (params) => {
		// If data is empty object (loading state), show shimmer
		if (params.data && Object.keys(params.data).length === 0) {
			return { component: ShimmerCellRendererEmployee };
		}
		return undefined;
	},
};

export default EmployeeCol;

const ShimmerCellRendererEmployee = () => {
	return (
		<div className="flex size-full items-center justify-center gap-1">
			<Skeleton className="size-6 shrink-0 rounded-full" />
			<Skeleton />
		</div>
	);
};
